import { useEffect, useState } from "react";
import { ArrowRight, Download } from "lucide-react";
import { SmartLink } from "../SmartLink";
import { useAuth } from "../../context/AuthContext";
import { IMG, resolveImg } from "./images";

const FALLBACK = [{ id: "f", image: IMG.heroFutures, title: "USDT-M Futures", subtitle: "Trade with up to 100x leverage", link: "/futures" }];

const Slider = ({ banners }) => {
  const slides = banners?.length ? banners : FALLBACK;
  const [i, setI] = useState(0);
  useEffect(() => {
    if (slides.length < 2) return undefined;
    const t = setTimeout(() => setI((v) => (v + 1) % slides.length), 6000);
    return () => clearTimeout(t);
  }, [i, slides.length]);
  const s = slides[i % slides.length];
  return (
    <div className="az-hero-banner" data-testid="az-hero-banner">
      <SmartLink href={s.link || "#"} className="az-hero-slide" key={s.id} data-testid={`az-hero-slide-${i}`}>
        <img src={resolveImg(s.image)} alt={s.title || "Imperio"} />
        {(s.title || s.subtitle) && <div className="az-hero-slide-cap"><b>{s.title}</b><span>{s.subtitle}</span></div>}
      </SmartLink>
      {slides.length > 1 && (
        <div className="az-dots">
          {slides.map((b, k) => (
            <button key={b.id} className={k === i % slides.length ? "on" : ""} onClick={() => setI(k)} aria-label={`Slide ${k + 1}`} data-testid={`az-hero-dot-${k}`} />
          ))}
        </div>
      )}
    </div>
  );
};

export const AzHero = ({ apps, banners }) => {
  const { user } = useAuth() || {};
  const appHref = apps?.android || apps?.ios || "#az-app";
  return (
    <section className="az-hero az-wrap" data-testid="az-hero">
      <div className="az-hero-copy">
        <h1>Trade crypto with<br />confidence on <span>Imperio</span></h1>
        <p>Fast, secure and easy-to-use exchange for spot, futures and earn — built for every trader.</p>
        <div className="az-hero-btns">
          {user ? (
            <SmartLink className="az-btn az-btn-primary" href="/trade" data-testid="az-hero-trade">Start trading <ArrowRight size={18} /></SmartLink>
          ) : (
            <SmartLink className="az-btn az-btn-primary" href="/register" data-testid="az-hero-signup">Sign Up <ArrowRight size={18} /></SmartLink>
          )}
          <a className="az-btn az-btn-ghost" href={appHref} {...(appHref.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})} data-testid="az-hero-download"><Download size={18} /> Download App</a>
        </div>
      </div>
      <Slider banners={banners} />
    </section>
  );
};
